import './index.scss';
type props = {
  text?: string;
};
const TableNullData = ({ text = 'اطلاعاتی برای نمایش وجود ندارد' }: props) => {
  return (
    <tbody id='table-loading-container'>
      <tr>
        <td colSpan={100}>
          <p>{text}</p>
        </td>
      </tr>
    </tbody>
  );
};

export default TableNullData;
